import {reducerWithInitialState} from "typescript-fsa-reducers";
import { graphInitialState, deepCopyGraphThingyState } from "../typing/states";
import {GraphThingyActions} from "../actions/actions";

export default reducerWithInitialState(graphInitialState)
        .case(GraphThingyActions.resetData, (state,payload) => {
            const deepCopy=deepCopyGraphThingyState(state);
            if (payload.data){
               deepCopy.config.data = payload.data;
               deepCopy.view.loaded = true;
              // deepCopy.config.color = deepCopy.config.color;
            }
            return deepCopy;
        })
        ;